import { render, staticRenderFns } from "./ViewSection.vue?vue&type=template&id=06e8b90e&scoped=true&"
var script = {}
import style0 from "./ViewSection.vue?vue&type=style&index=0&id=06e8b90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8b90e",
  null
  
)

export default component.exports